import React from 'react'
import styles from './Text2.module.scss'
import cl from 'classnames'
import { Text2Props } from './Text2.types'

const Text2Component = (props: Text2Props) => {
  const {
    bold,
    overflowEllipsis,
    className,
    children,
    ...rest
  } = props

  return (
    <p
      className={cl(styles.text2, {
        [styles.bold]: bold,
        [styles.textOverflow]: overflowEllipsis
      }, className)}
      {...rest}
    >
      {children}
    </p>
  )
}

const Text2 = Text2Component
export { Text2 }
